<template>
	<div class="first-highlight-box">
		<p>
			Please review the highlighted sections. Click the edit icon to verify or
			update the information.
		</p>
		<div class="d-flex justify-content-end">
			<b-button @click="$emit('submit')" class="candash-addBtn-sm">
				Okay
			</b-button>
		</div>
	</div>
</template>

<script>
export default {};
</script>

<style>
@media (max-width: 1028px) {
	.first-highlight-box {
		font-size: 13px !important;
		top: -109px !important;
		right: -12px !important;
		width: 259px;
	}
}
.first-highlight-box {
	background-color: #ffffff;
	color: #92400e;
	padding: 6px 10px;
	border: 1px solid #8c8c8c54;
	box-shadow: 0px 4px 8px 0px #0000002b;
	max-width: 330px;
	border-radius: 8px;
	font-size: 16px;
	font-weight: 500;
	font-family: "montserrat", sans-serif;
	color: #333333;
	position: absolute;
	top: 57px;
	right: -19px;
	z-index: 5;
}
</style>
